import React from 'react';
import { MapControl } from '@vis.gl/react-google-maps';
import { useRef, useEffect, useState } from 'react';
import { useMapsLibrary } from '@vis.gl/react-google-maps';


export const CustomMapControl = ({
  handleCoordinates,
  handleCity,
  controlPosition,
  onPlaceSelect,
  handleEmarites
}) => {

  const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
  const inputRef = useRef(null);
  const places = useMapsLibrary('places');

  useEffect(() => {

    if (!places || !inputRef.current) return;

    const options = {
      fields: ['geometry', 'name', 'formatted_address']
    };

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places]);

  useEffect(() => {

    if (!placeAutocomplete) return;

    placeAutocomplete.addListener('place_changed', () => {

      const newCenter = {
                  lat: placeAutocomplete.getPlace().geometry?.location?.lat(),
                  lng: placeAutocomplete.getPlace().geometry?.location?.lng()
                };
      
      const components = placeAutocomplete.getPlace()?.address_components;
     
      let emirate = null;
      console.log("components",components)
      if(components){
          emirate = components.find(component => 
          component.types.includes("administrative_area_level_1")
        )?.long_name;
      }
    
      //set coordinates
      handleCoordinates(newCenter);

      // set city
      handleCity(placeAutocomplete.getPlace()?.formatted_address);

      // set Emarites
      handleEmarites(emirate || "Unknown Emirate");

      onPlaceSelect(placeAutocomplete.getPlace());
    });

  }, [onPlaceSelect, placeAutocomplete]);



  return (
    <MapControl position={controlPosition}>
      <div className="autocomplete-control z-index-9999">
            <div className="autocomplete-container">
            <input
                id="searchInput"
                ref={inputRef} 
                onChange={()=> handleCoordinates('')}
              />
            </div>
      </div>
    </MapControl>
  );
};
